import { useState, useCallback } from 'react';

/**
 * Hook for managing item selection in the SingleCustomCollection list
 */
export function useItemSelection() {
  const [selectedItems, setSelectedItems] = useState(new Set());

  // Handle individual item selection
  const handleSelectItem = useCallback((itemId, isSelected) => {
    setSelectedItems(prevSelected => {
      const newSelected = new Set(prevSelected);
      if (isSelected) {
        newSelected.add(itemId);
      } else {
        newSelected.delete(itemId);
      }
      return newSelected;
    });
  }, []);

  // Handle select all items
  const handleSelectAll = useCallback((isSelected, items) => {
    if (isSelected) {
      const allIds = new Set(items.map(item => item._id));
      setSelectedItems(allIds);
    } else {
      setSelectedItems(new Set());
    }
  }, []);

  // Clear all selections
  const clearSelection = useCallback(() => {
    setSelectedItems(new Set());
  }, []);

  // Get selection state for UI indicators
  const getSelectionState = useCallback((items) => {
    const isAllSelected = items.length > 0 && selectedItems.size === items.length;
    const isIndeterminate = selectedItems.size > 0 && selectedItems.size < items.length;
    return { isAllSelected, isIndeterminate };
  }, [selectedItems]);

  return {
    selectedItems,
    handleSelectItem,
    handleSelectAll,
    clearSelection,
    getSelectionState,
    setSelectedItems
  };
}